<script setup lang="ts">
import {storeToRefs} from "pinia";
import {useLayoutsStore} from "@/composables/layouts";

const {switchLayout} = storeToRefs(useLayoutsStore());
</script>

<template>
  <KeepAlive>
    <component :is="switchLayout">
      <router-view/>
    </component>
  </KeepAlive>
</template>